/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/wsp/wsp_Perms.js";

const r = REG.reg;
r.newPerm("ui.wspApp", "use.wsp", 0);
r.newPerm("ui.wspDocApp", "use.wsp", 0);
r.newPerm("ui.taskApp", "use.wsp", 0);
r.newPerm("ui.wspsPlg.manage", "admin.wsp", 0);
r.newPerm("ui.wspsPlg.create", "create.wsp", 0);
r.newPerm("ui.wspsPlg", "list.wsps", 0);
r.newPerm("ui.tasksPlg", "read.repos.task", 0);
r.newPerm("ui.wspsPlg.import", "create.wsp.import", 0);
